(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-cart-drawer"]) return;
  try {
    
  const drawerRoot = () => document.querySelector('[data-lip-cart-drawer]');

  const setCartOpen = (open) => {
    const el = drawerRoot();
    if (!el) return;
    el.classList.toggle('is-open', open);
    document.body.classList.toggle('lip-cart-open', open);
    if (open) {
      el.querySelector('[data-lip-cart-close]:not(.lip-cart-drawer__scrim)')?.focus();
    }
  };

  const syncCount = () => {
    const countEl = document.getElementById('LipCartCount');
    const count = countEl ? countEl.textContent.trim() : '';
    document.querySelectorAll('[data-lip-cart-count]').forEach((node) => {
      node.textContent = count && count !== '0' ? ` ${count}` : '';
    });
  };

  const refreshCart = async () => {
    const current = drawerRoot();
    if (!current) return;
    const wasOpen = current.classList.contains('is-open');
    const response = await fetch('/cart?section_id=lip-cart-drawer');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-lip-cart-drawer]');
    if (!next) return;
    current.replaceWith(next);
    if (wasOpen) setCartOpen(true);
    syncCount();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-lip-account-open]')) {
      setCartOpen(false);
    }
    if (event.target.closest('[data-lip-cart-open]')) {
      event.preventDefault();
      setCartOpen(true);
      return;
    }
    if (event.target.closest('[data-lip-cart-close]')) {
      event.preventDefault();
      setCartOpen(false);
    }
    const remove = event.target.closest('[data-lip-cart-remove]');
    if (remove) {
      event.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.getAttribute('data-lip-cart-remove'), quantity: 0 }),
      }).then(refreshCart);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawerRoot()?.classList.contains('is-open')) {
      setCartOpen(false);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.closest('[data-lip-cart-drawer]')) return;
    const isSingleOffer = form.matches('[data-lip-single-offer="true"]');
    const checkoutAfterAdd = Boolean(form.querySelector('[name="return_to"][value="/checkout"]'));
    if (checkoutAfterAdd && !isSingleOffer) return;
    if (!form.querySelector('[name="id"]')) return;
    if (!isSingleOffer && !form.querySelector('[name="add"], button[name="add"]')) return;
    event.preventDefault();

    const replaceExistingSingleOffer = async () => {
      if (!isSingleOffer) return;
      const keys = [...(drawerRoot()?.querySelectorAll('[data-lip-single-offer-item]') || [])]
        .map((item) => item.getAttribute('data-lip-single-offer-item'))
        .filter(Boolean);
      for (const key of keys) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        if (!response.ok) throw new Error('replace');
      }
    };

    replaceExistingSingleOffer()
      .then(() => fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }))
      .then((response) => {
        if (!response.ok) throw new Error('add');
        if (checkoutAfterAdd) {
          window.location.assign('/checkout');
          return;
        }
        return refreshCart().then(() => setCartOpen(true));
      })
      .catch(() => form.submit());
  });

  if (document.body.classList.contains('template-cart')) {
    setCartOpen(true);
  }

  syncCount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-collection"]) return;
  try {
    
  document.querySelectorAll('[data-lip-library]').forEach((library) => {
    const search = library.querySelector('[data-lip-library-search]');
    const duration = library.querySelector('[data-lip-library-duration]');
    const count = library.querySelector('[data-lip-library-count]');
    const empty = library.querySelector('[data-lip-library-empty]');
    const cards = [...library.querySelectorAll('[data-lip-practice-card]')];

    const applyFilters = () => {
      const query = search.value.trim().toLowerCase();
      const durationFilter = duration.value;
      let visible = 0;

      cards.forEach((card) => {
        const minutes = Number(card.dataset.lipDurationMinutes);
        const matchesSearch = !query || card.dataset.lipSearch.includes(query);
        let matchesDuration = durationFilter === 'all';

        if (Number.isFinite(minutes)) {
          if (durationFilter === 'short') matchesDuration = minutes <= 20;
          if (durationFilter === 'medium') matchesDuration = minutes > 20 && minutes <= 40;
          if (durationFilter === 'long') matchesDuration = minutes > 40;
        }

        const matches = matchesSearch && matchesDuration;
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      count.textContent = `${visible} ${visible === 1 ? 'class' : 'classes'}`;
      empty.hidden = visible !== 0;
    };

    search.addEventListener('input', applyFilters);
    duration.addEventListener('change', applyFilters);
    document.addEventListener('lip:duration-loaded', applyFilters);
    applyFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-favourites"]) return;
  try {
    
  const favouritesPage = document.querySelector('[data-lip-favourites-page]');
  if (favouritesPage) {
    window.location.replace(favouritesPage.dataset.destination);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-header"]) return;
  try {
    
  const header = document.querySelector('[data-lip-header]');
  const dialog = document.querySelector('[data-lip-account-dialog]');
  const isDialog = dialog instanceof HTMLDialogElement;

  let menuLeave;
  let accountLeave;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const closeMenu = () => {
    if (!header?.classList.contains('is-open')) return;
    header.classList.remove('is-open');
    const toggle = header.querySelector('[data-lip-menu-toggle]');
    const overlay = header.querySelector('#LipMenu');
    const label = header.querySelector('[data-lip-menu-label]');
    toggle?.setAttribute('aria-expanded', 'false');
    if (label && toggle) label.textContent = toggle.getAttribute('data-open-label');
    document.body.style.overflow = '';
    window.clearTimeout(menuLeave);
    if (!overlay) return;
    if (reduceMotion) {
      overlay.hidden = true;
      overlay.classList.remove('is-leaving');
      return;
    }
    overlay.classList.add('is-leaving');
    menuLeave = window.setTimeout(() => {
      overlay.hidden = true;
      overlay.classList.remove('is-leaving');
    }, 200);
  };

  const setPlan = (handle) => {
    if (!dialog) return;
    dialog.querySelectorAll('[data-lip-plan]').forEach((plan) => {
      plan.classList.toggle('is-current', Boolean(handle) && plan.getAttribute('data-lip-plan') === handle);
    });
  };

  const setAccountView = (name) => {
    if (!dialog) return;
    const view = name === 'register' ? 'join' : name;
    dialog.querySelectorAll(':scope > [data-lip-account-view]').forEach((el) => {
      el.hidden = el.getAttribute('data-lip-account-view') !== view;
    });
    const focus = dialog.querySelector(`[data-lip-account-view="${view}"] .lip-join-plan__go`);
    focus?.focus();
  };

  const clickShopifyAccount = (account) => {
    const root = account.shadowRoot;
    const avatar = root?.querySelector('[part="signed-out-avatar"]');
    const button = root?.querySelector('button');
    (avatar || button || account).click();
  };

  const openShopifyLogin = () => {
    closeAccount(true);
    closeMenu();
    document.body.style.overflow = '';

    const run = () => {
      const account = document.querySelector('shopify-account');
      if (!account) return;
      const bottom = Math.max(0, Math.round(account.getBoundingClientRect().bottom));
      account.style.setProperty('--account-dialog-top', `${bottom}px`);
      clickShopifyAccount(account);
    };

    const start = () => {
      requestAnimationFrame(() => requestAnimationFrame(run));
    };

    if (customElements.get('shopify-account')) start();
    else customElements.whenDefined('shopify-account').then(start);
  };

  const openAccount = (name, plan) => {
    if (name === 'login') {
      openShopifyLogin();
      return;
    }
    if (!dialog) return;
    closeMenu();
    setAccountView(name || 'join');
    setPlan(plan || '');
    if (!isDialog) return;
    window.clearTimeout(accountLeave);
    dialog.classList.remove('is-leaving');
    if (!dialog.open) dialog.showModal();
    document.body.style.overflow = 'hidden';
  };

  const closeAccount = (immediate) => {
    if (!isDialog || !dialog.open) {
      if (isDialog) document.body.style.overflow = '';
      return;
    }
    window.clearTimeout(accountLeave);
    if (immediate || reduceMotion) {
      dialog.classList.remove('is-leaving');
      dialog.close();
      document.body.style.overflow = '';
      return;
    }
    dialog.classList.add('is-leaving');
    accountLeave = window.setTimeout(() => {
      dialog.close();
      dialog.classList.remove('is-leaving');
      document.body.style.overflow = '';
    }, 200);
  };

  if (header) {
    const toggle = header.querySelector('[data-lip-menu-toggle]');
    const overlay = header.querySelector('#LipMenu');
    const label = header.querySelector('[data-lip-menu-label]');
    toggle?.addEventListener('click', () => {
      if (header.classList.contains('is-open')) {
        closeMenu();
        return;
      }
      window.clearTimeout(menuLeave);
      overlay?.classList.remove('is-leaving');
      header.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      if (label) label.textContent = toggle.getAttribute('data-close-label');
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (document.body.classList.contains('is-customer')) return;
      const link = event.target.closest('a[href]');
      if (!link || link.closest('shopify-account')) return;
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      const path = url.pathname.replace(/\/+$/, '') || '/';
      const loginPath =
        path === '/account' ||
        path === '/account/login' ||
        path === '/account/register' ||
        path.startsWith('/customer_authentication');
      if (!loginPath) return;
      event.preventDefault();
      event.stopPropagation();
      openShopifyLogin();
    },
    true
  );

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-lip-account-open]');
    if (openTrigger) {
      event.preventDefault();
      openAccount(
        openTrigger.getAttribute('data-lip-account-open') || 'join',
        openTrigger.getAttribute('data-lip-plan') || ''
      );
      return;
    }

    if (event.target.closest('[data-lip-shopify-login]')) {
      event.preventDefault();
      openShopifyLogin();
      return;
    }

    if (event.target.closest('[data-lip-account-close]')) {
      event.preventDefault();
      closeAccount();
      return;
    }

    const viewTrigger = event.target.closest('[data-lip-account-view]');
    if (viewTrigger?.tagName === 'BUTTON') {
      event.preventDefault();
      setAccountView(viewTrigger.getAttribute('data-lip-account-view'));
    }
  });

  dialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeAccount();
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    const clickedInside =
      event.clientX >= bounds.left &&
      event.clientX <= bounds.right &&
      event.clientY >= bounds.top &&
      event.clientY <= bounds.bottom;
    if (!clickedInside) closeAccount();
  });

  dialog?.addEventListener('close', () => {
    document.body.style.overflow = '';
  });

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (dialog) {
    const errored = dialog.querySelector('.lip-join-dialog__errors');
    const initial = errored?.closest('[data-lip-account-view]')?.getAttribute('data-lip-account-view')
      || dialog.getAttribute('data-open');
    if (initial) openAccount(initial);
  }

  const clocks = document.querySelectorAll('[data-lip-clock]');
  if (clocks.length) {
    const write = () => {
      const now = new Date();
      const zoneName = 'Australia/Sydney';
      const time = new Intl.DateTimeFormat('en-AU', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: zoneName,
      }).format(now);
      const zone = new Intl.DateTimeFormat('en-AU', {
        timeZone: zoneName,
        timeZoneName: 'short',
      })
        .formatToParts(now)
        .find((part) => part.type === 'timeZoneName');
      const label = `${time} ${zone ? zone.value : ''}`.replace(/\s+/g, ' ').trim().toUpperCase();
      const iso = now.toISOString();
      clocks.forEach((node) => {
        node.textContent = label;
        node.setAttribute('datetime', iso);
      });
    };
    write();
    const delay = 60000 - (Date.now() % 60000);
    window.setTimeout(() => {
      write();
      window.setInterval(write, 60000);
    }, delay);
  }

  if (
    !document.body.classList.contains('is-customer') &&
    /template-login|template-customers-login/.test(document.body.className)
  ) {
    openShopifyLogin();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-practice-dialog"]) return;
  try {
    
  const practiceDialog = document.querySelector('[data-lip-practice-dialog]');

  if (practiceDialog instanceof HTMLDialogElement) {
    const media = practiceDialog.querySelector('[data-lip-practice-media]');
    const title = practiceDialog.querySelector('[data-lip-practice-title]');
    const details = practiceDialog.querySelector('[data-lip-practice-details]');
    const commentsLink = practiceDialog.querySelector('[data-lip-practice-comments-link]');
    let opener;

    const closePractice = () => practiceDialog.close();

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-lip-practice-open]');
      if (trigger) {
        const card = trigger.closest('.lip-practice-card');
        const template = card?.querySelector('[data-lip-practice-template]');
        if (!template || !(template instanceof HTMLTemplateElement)) return;
        event.preventDefault();
        opener = trigger;
        title.textContent = card.querySelector('.lip-card__title')?.textContent?.trim() || '';
        details.innerHTML = card.querySelector('.lip-card__details')?.innerHTML || '';
        const practiceUrl = card.dataset.lipPracticeUrl;
        if (practiceUrl) {
          commentsLink.href = `${practiceUrl}#PracticeComments`;
          commentsLink.hidden = false;
        } else {
          commentsLink.removeAttribute('href');
          commentsLink.hidden = true;
        }
        details.querySelectorAll('[data-lip-practice-duration]').forEach(loadDuration);
        media.replaceChildren(template.content.cloneNode(true));
        practiceDialog.showModal();
        document.body.style.overflow = 'hidden';
        practiceDialog.querySelector('[data-lip-practice-close]')?.focus();
        return;
      }

      if (event.target.closest('[data-lip-practice-close]')) {
        closePractice();
      }
    });

    practiceDialog.addEventListener('click', (event) => {
      if (event.target !== practiceDialog) return;
      const bounds = practiceDialog.getBoundingClientRect();
      const clickedInside =
        event.clientX >= bounds.left &&
        event.clientX <= bounds.right &&
        event.clientY >= bounds.top &&
        event.clientY <= bounds.bottom;
      if (!clickedInside) closePractice();
    });

    practiceDialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePractice();
    });

    practiceDialog.addEventListener('close', () => {
      media.replaceChildren();
      commentsLink.removeAttribute('href');
      commentsLink.hidden = true;
      document.body.style.overflow = '';
      opener?.focus();
    });

    const formatDuration = (seconds) => `${Math.max(1, Math.round(seconds / 60))} min`;
    const durationCache = new Map();

    const loadDuration = async (node) => {
      const videoId = node.dataset.vimeoId;
      if (!videoId || node.textContent) return;
      if (!durationCache.has(videoId)) {
        durationCache.set(
          videoId,
          fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${videoId}`)}`)
            .then((response) => {
              if (!response.ok) throw new Error('duration');
              return response.json();
            })
            .then((data) => {
              const seconds = Number(data.duration);
              return { label: formatDuration(seconds), minutes: seconds / 60 };
            })
            .catch(() => null)
        );
      }
      const result = await durationCache.get(videoId);
      if (!result) return;
      node.textContent = result.label;
      const card = node.closest('[data-lip-practice-card]');
      if (card) {
        card.dataset.lipDurationMinutes = result.minutes;
        document.dispatchEvent(new CustomEvent('lip:duration-loaded'));
      }
    };

    const observeDurations = () => {
      const durationNodes = [...document.querySelectorAll('[data-lip-practice-duration]')];
      const eagerNodes = durationNodes.filter((node) => node.closest('[data-lip-library]'));
      const lazyNodes = durationNodes.filter((node) => !node.closest('[data-lip-library]'));
      eagerNodes.forEach(loadDuration);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            loadDuration(entry.target);
          });
        }, { rootMargin: '240px' });
        lazyNodes.forEach((node) => observer.observe(node));
      } else {
        lazyNodes.forEach(loadDuration);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeDurations, { once: true });
    } else {
      observeDurations();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lip-product"]) return;
  try {
    
  const initProductSlides = (scope = document) => {
    scope.querySelectorAll('[data-lip-product-slides]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const slides = Array.from(carousel.querySelectorAll('.lip-product__slide'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (slides.length < 2 || reduceMotion) return;

      const interval = Number(carousel.dataset.interval) || 4000;
      let activeIndex = 0;
      let timer;

      const showNext = () => {
        slides[activeIndex].classList.remove('is-active');
        slides[activeIndex].setAttribute('aria-hidden', 'true');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
        slides[activeIndex].removeAttribute('aria-hidden');
      };

      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(showNext, interval);
      };

      start();
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          window.clearInterval(timer);
        } else {
          start();
        }
      });
    });
  };

  initProductSlides();
  document.addEventListener('shopify:section:load', (event) => initProductSlides(event.target));

  } catch(e) { console.error(e); }
})();
})();
